import { Box, Flex, Icon, Text, useColorModeValue, Spinner, Center } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import BarChart from "components/charts/BarChart";
import React, { useState, useEffect } from "react";
import { MdBarChart } from "react-icons/md";
import axios from "axios";
import { API_URL } from "../../../../constants";
import {getAuthToken} from "../../../../helpers/helpers"

export default function WeeklyRevenue({ startDate, endDate, ...rest }) {
  const [top10, setTop10] = useState([]);
  const [value, setValue] = useState([]);
  const [chartKey, setChartKey] = useState(0); // Clé pour forcer le rerendu
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const token = getAuthToken();

      try {
        const response = await axios.get(
          `${API_URL}/api/track/action/AFFICHER_TRAITEMENT`,
          {
            headers: {
              "x-access-token": token,
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Ajout du filtre selon la plage de dates
        const filteredData = response.data.filter((item) => {
          const createdAt = new Date(item.created_at);
          if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            return createdAt >= start && createdAt <= end;
          }
          return true;
        });

        const selectedPathologies = filteredData.flatMap(
          (item) => item.data.selectedPathologies
        );

        const counter = selectedPathologies.reduce((accumulator, currVal) => {
          const pathology = currVal.pathologie;
          if (Object.keys(accumulator).some((elem) => elem === pathology)) {
            accumulator[pathology] += 1;
          } else {
            accumulator[pathology] = 1;
          }
          return accumulator;
        }, {});

        const sortedCounterArray = Object.entries(counter).sort(
          (a, b) => b[1] - a[1]
        );

        const top10Pathologies = sortedCounterArray
          .slice(0, 10)
          .map((item) => item[0]);

        setValue(sortedCounterArray.slice(0, 10).map((item) => item[1]));
        setTop10(top10Pathologies);

        setChartKey((prevKey) => prevKey + 1);
        setIsLoading(false);
      } catch (error) {
        console.log("Error making the request:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]); 

  const barChartDataConsumption = [
    {
      name: "Nb de consultations",
      data: value,
    },
  ];

  const barChartOptionsConsumption = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
      onDatasetHover: {
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
      },
    },
    xaxis: {
      categories: top10,
      show: false,
      labels: {
        show: true,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
      color: "black",
      labels: {
        show: false,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
    },

    grid: {
      borderColor: "rgba(163, 174, 208, 0.3)",
      show: true,
      yaxis: {
        lines: {
          show: false,
          opacity: 0.5,
        },
      },
      row: {
        opacity: 0.5,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      type: "solid",
      colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
    },
    legend: {
      show: false,
    },
    colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "20px",
      },
    },
  };

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("brand.500", "white");

  if (isLoading) {
    return (
      <Card align="center" direction="column" w="100%" {...rest} minH="300px">
        <Flex align="center" w="100%" px="15px" py="10px">
          <Text
            me="auto"
            color={textColor}
            fontSize="xl"
            fontWeight="700"
            lineHeight="100%"
          >
            Plaintes les plus consultées
          </Text>
          <Icon as={MdBarChart} color={iconColor} w="24px" h="24px" />
        </Flex>
        <Center h="100%" minH="200px">
          <Flex direction="column" align="center" gap="4">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.500"
              size="xl"
            />
            <Text color="secondaryGray.600" fontSize="sm" fontWeight="500">
              Chargement des plaintes...
            </Text>
          </Flex>
        </Center>
      </Card>
    );
  }

  return (
    <Card align="center" direction="column" w="100%" {...rest}>
      <Flex align="center" w="100%" px="15px" py="10px">
        <Text
          me="auto"
          color={textColor}
          fontSize="xl"
          fontWeight="700"
          lineHeight="100%"
        >
          Plaintes les plus consultées
        </Text>
        <Icon as={MdBarChart} color={iconColor} w="24px" h="24px" />
      </Flex>

      <Box h="250px" mt="auto">
        {top10.length > 0 && value.length > 0 && (
          <BarChart
            key={chartKey} 
            chartData={barChartDataConsumption}
            chartOptions={barChartOptionsConsumption}
          />
        )}
      </Box>
    </Card>
  );
}
